import React, { useEffect, useState } from 'react';
import './ContactBody.css';
import { AnimatedSection } from '../../AnimatedSection';
import { db } from '../../../firebase';
import { collection, addDoc } from 'firebase/firestore';

const ContactBody = () => {
    // Form state management


    const playerImages = [
        '/home_data/section2/Frame 47.png',
        '/home_data/section2/Frame 47 (1).png',
        '/home_data/section2/Bill Russel.png',
        '/home_data/section2/Brandi Chastain.png',
        '/home_data/section2/Serena.png',
        '/home_data/section2/Vince Lombardi.png',
        '/home_data/section2/Willis Reed - GAME 7.png',
        '/home_data/section2/image 1.png'
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === playerImages.length - 1 ? 0 : prevIndex + 1
            );
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const [formData, setFormData] = useState({
        role: '',
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        message: ''
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(''); // 'success' or 'error'

    // Validation functions
    const validateName = (name) => {
        const nameRegex = /^[a-zA-Z\s]+$/;
        return nameRegex.test(name) && name.trim().length >= 2;
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePhone = (phone) => {
        const phoneRegex = /^[\+]?[0-9\s\-\(\)]+$/;
        return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 10;
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    // Handle radio button changes
    const handleRadioChange = (e) => {
        setFormData(prev => ({
            ...prev,
            role: e.target.value
        }));
        if (errors.role) {
            setErrors(prev => ({
                ...prev,
                role: ''
            }));
        }
    };

    // Validate entire form
    const validateForm = () => {
        const newErrors = {};

        // Validate role selection
        formData.role = 'No display. hide';
        if (!formData.role) {
            newErrors.role = 'Please select your role';
        }

        // Validate first name
        if (!formData.firstName.trim()) {
            newErrors.firstName = 'First name is required';
        } else if (!validateName(formData.firstName)) {
            newErrors.firstName = 'First name must contain only letters';
        }

        // Validate last name
        if (!formData.lastName.trim()) {
            newErrors.lastName = 'Last name is required';
        } else if (!validateName(formData.lastName)) {
            newErrors.lastName = 'Last name must contain only letters';
        }

        // Validate email
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!validateEmail(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        // Validate phone number
        if (!formData.phoneNumber.trim()) {
            newErrors.phoneNumber = 'Phone number is required';
        } else if (!validatePhone(formData.phoneNumber)) {
            newErrors.phoneNumber = 'Please enter a valid phone number';
        }

        // Validate message
        if (!formData.message.trim()) {
            newErrors.message = 'Message is required';
        } else if (formData.message.trim().length < 10) {
            newErrors.message = 'Message must be at least 10 characters long';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
        setSubmitStatus('');

        try {
            // Save to Firebase
            await addDoc(collection(db, 'contacts'), {
                ...formData,
                timestamp: new Date(),
                createdAt: new Date().toISOString()
            });

            // Success
            setSubmitStatus('success');
            setFormData({
                role: '',
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                message: ''
            });

            // Hide success message after 5 seconds
            setTimeout(() => {
                setSubmitStatus('');
            }, 5000);

        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (


        <section className="contactbody section">

            <div className="min-h-screen bg-black flex flex-col md:flex-row contact-container">
                {/* Left side: Image */}
                <div className="md:w-2/5 items-center justify-center relative flex p-10">
                    <AnimatedSection>

                        <img
                            src={playerImages[currentImageIndex]}
                            alt="Player"
                            className="w-full h-[130vw] md:h-auto object-cover"
                        />

                        {/* <img
                            src="/contact_data/bodysection/Photo Frame.png"
                            alt="GAME7 player"
                            className="w-full h-auto object-cover"
                        /> */}

                    </AnimatedSection> 
                    {/* If you want overlay text like "GAME7", uncomment below */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <img
                            src="/contact_data/bodysection/Photo Frame.svg"
                            alt="GAME7 player"  className="w-1/3"
                        />
                    </div>
                </div>

                {/* Right side: Form */}
                <div className="md:w-3/5 items-center justify-center pt-20 pr-10 pb-10 pl-10 md:pl-32">
                    <form onSubmit={handleSubmit} className="w-100   space-y-8 text-white contact-options">
                        {/* Radio Buttons */}

                        <div>
                            <AnimatedSection><p className="mb-7">I am:</p></AnimatedSection>
                            <div className="flex flex-col md:flex-row flex-wrap gap-4 justify-between hidden">
                                <AnimatedSection><label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="role"
                                        value="athlete"
                                        checked={formData.role === 'athlete'}
                                        onChange={handleRadioChange}
                                        className="mr-2"
                                    /> An Athlete
                                </label></AnimatedSection>
                                <AnimatedSection><label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="role"
                                        value="partner"
                                        checked={formData.role === 'partner'}
                                        onChange={handleRadioChange}
                                        className="mr-2"
                                    /> A Partner
                                </label></AnimatedSection>
                                <AnimatedSection><label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="role"
                                        value="press"
                                        checked={formData.role === 'press'}
                                        onChange={handleRadioChange}
                                        className="mr-2"
                                    /> Press
                                </label></AnimatedSection>
                                <AnimatedSection><label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="role"
                                        value="client"
                                        checked={formData.role === 'client'}
                                        onChange={handleRadioChange}
                                        className="mr-2"
                                    /> Client
                                </label></AnimatedSection>
                            </div>
                            {errors.role && <p className="text-red-400 text-sm mt-2">{errors.role}</p>}
                        </div>

                        {/* Inputs */}
                        <div className='flex flex-col gap-5'>
                            <AnimatedSection>
                                <div>
                                    <input
                                        className={`w-full contact-form-input ${errors.firstName ? 'border-red-400' : ''}`}
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleInputChange}
                                        placeholder="First Name"
                                    />
                                    {errors.firstName && <p className="text-red-400 text-sm mt-1">{errors.firstName}</p>}
                                </div>
                            </AnimatedSection>
                            <AnimatedSection>
                                <div>
                                    <input
                                        className={`w-full contact-form-input ${errors.lastName ? 'border-red-400' : ''}`}
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleInputChange}
                                        placeholder="Last Name"
                                    />
                                    {errors.lastName && <p className="text-red-400 text-sm mt-1">{errors.lastName}</p>}
                                </div>
                            </AnimatedSection>
                            <AnimatedSection>
                                <div>
                                    <input
                                        className={`w-full contact-form-input ${errors.email ? 'border-red-400' : ''}`}
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="Email Address"
                                    />
                                    {errors.email && <p className="text-red-400 text-sm mt-1">{errors.email}</p>}
                                </div>
                            </AnimatedSection>
                            <AnimatedSection>
                                <div>
                                    <input
                                        className={`w-full contact-form-input ${errors.phoneNumber ? 'border-red-400' : ''}`}
                                        type="tel"
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleInputChange}
                                        placeholder="Phone Number"
                                    />
                                    {errors.phoneNumber && <p className="text-red-400 text-sm mt-1">{errors.phoneNumber}</p>}
                                </div>
                            </AnimatedSection>
                            <AnimatedSection>
                                <div>
                                    <textarea
                                        className={`w-full contact-form-input ${errors.message ? 'border-red-400' : ''}`}
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        placeholder="Message"
                                        rows={5}
                                    />
                                    {errors.message && <p className="text-red-400 text-sm mt-1">{errors.message}</p>}
                                </div>
                            </AnimatedSection>
                        </div>

                        {/* Success/Error Messages */}
                        {submitStatus === 'success' && (
                            <div className="bg-black-600 text-white p-4 rounded-lg">
                                ✅ Thank you! Your message has been sent successfully.
                            </div>
                        )}

                        {submitStatus === 'error' && (
                            <div className="bg-red-600 text-white p-4 rounded-lg">
                                ❌ Sorry, there was an error sending your message. Please try again.
                            </div>
                        )}

                        {/* Submit Button */}
                        <AnimatedSection>
                            <div className="w-full flex justify-center md:justify-start">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`site-dft-btn-contact rounded-lg ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                    {isSubmitting ? 'SENDING...' : 'CONTACT US'}
                                </button>
                            </div>
                        </AnimatedSection>
                    </form>
                </div>
            </div >

        </section >
    );
};

export default ContactBody;

